import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzMultiSelectItem, MultiSelectEvents } from '../types';

export class GzMultiSelectItemWebComponent extends LitElement implements GzMultiSelectItem {
  @property({ type: Boolean, attribute: true, reflect: true })
  selected = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  disabled = false;

  @property({ type: String, attribute: true, reflect: true })
  value: string | number;

  @property({ type: String, attribute: true, reflect: true })
  label: string;

  @property({ type: Boolean, attribute: true, reflect: true })
  invalid = false;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  constructor() {
    super();
    this.addEventListener('click', this.clickHandler);
  }

  render() {
    return html` <button @click="${this.setSelected}">${this.label}</button> `;
  }

  private setSelected() {
    this.selected = !this.selected;

    const { label, value } = this;

    const event = new CustomEvent(MultiSelectEvents.CHANGE, {
      detail: {
        label,
        value,
      },
      bubbles: true,
    });
    this.dispatchEvent(event);
  }

  private clickHandler(e: Event) {
    (e.target as HTMLElement).blur();
    if (this.disabled) {
      e.stopImmediatePropagation();
    }
  }
}
